import type { SummaryField } from '@/pages/quotation-design/types';
import SectionTitle from './SectionTitle';

export default function CommercialSummary({ fields }: { fields: SummaryField[] }) {
  return (
    <div className="px-6 md:px-9 mt-7">
      <SectionTitle>Commercial Summary</SectionTitle>
      <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2.5">
        {fields
          .filter((f) => f.value && f.value.trim() !== '')
          .map((f) => (
            <div
              key={f.label}
              className="flex items-start justify-between gap-4 border-b border-ink-100/70 pb-2"
            >
              <span className="text-xs text-ink-400 whitespace-nowrap">{f.label}</span>
              <span
                className={`text-sm text-right ${
                  f.pending
                    ? 'text-ink-400 italic'
                    : 'font-medium text-ink-700'
                }`}
              >
                {f.value}
              </span>
            </div>
          ))}
      </div>
    </div>
  );
}